import React from 'react';
import { getTypeOptions, getTypeOptionsWithPremiumV1 } from '../constants/subscriptionTypes';

/**
 * TypeSelector Component
 * Dropdown for selecting subscription type filter
 *
 * @param {Object} props
 * @param {string} props.value - Currently selected type
 * @param {function} props.onChange - Callback when selection changes
 * @param {boolean} props.required - Whether selection is required
 * @param {string} props.label - Label text (default: "Előfizetés típusa")
 * @param {boolean} props.includePremiumV1 - Whether to include Premium V1 option (default: false)
 */
const TypeSelector = ({
  value,
  onChange,
  required = false,
  label = 'Előfizetés típusa',
  includePremiumV1 = false,
}) => {
  const options = includePremiumV1 ? getTypeOptionsWithPremiumV1() : getTypeOptions();

  return (
    <div className="flex flex-col mb-4">
      <label className="text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-orange"
        required={required}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TypeSelector;
